var CandidateProfile = /** @class */ (function () {
    function CandidateProfile() {
        this.id = null;
        this.name;
        this.firstName;
        this.lastName;
        this.title;
        this.companyName;
        this.educations = [];
        this.experiences = [];
        this.certifications = [];
        this.compensations = [];
        this.technicalSkills = [];
        this.softSkills = [];
        this.others = [];
    }
    return CandidateProfile;
}());
export { CandidateProfile };
//# sourceMappingURL=candidateProfile.js.map